"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDelegatee = void 0;
var pstruct_1 = require("../../../PTypes/PStruct/pstruct.js");
var PPubKeyHash_1 = require("../../V1/PubKey/PPubKeyHash.js");
var PDRep_1 = require("../Governance/PDRep.js");
exports.PDelegatee = (0, pstruct_1.pstruct)({
    DelegStake: { poolId: PPubKeyHash_1.PPubKeyHash.type },
    DelegVote: { drep: PDRep_1.PDrep.type },
    DelegStakeVote: { poolId: PPubKeyHash_1.PPubKeyHash.type, drep: PDRep_1.PDrep.type }
});
